import { render } from "./BtnChevronRight.vue?vue&type=template&id=23d978ca"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/BtnChevronRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23d978ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23d978ca', __exports__)) {
    api.reload('23d978ca', __exports__)
  }
  
  module.hot.accept("./BtnChevronRight.vue?vue&type=template&id=23d978ca", () => {
    api.rerender('23d978ca', render)
  })

}


export default __exports__